module.exports = __webpack_public_path__ + "img/partner_8.86b9d232.png";